// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__s4fH0","footerContent":"styles_footerContent__HOQVJ","address":"styles_address__lh+J6"};